import { createContext } from "react";
import staticData from "../store_menu_details.json";

export const CategoryContext = createContext({ ...staticData.store_menu, setCategoryData: () => { } });